/**
 * The workspace switch for binding by hierarchy (migration 959; owner ruling 2026-10-28, D2).
 * Default off. Drawn only for a workspace admin (build contract §2.8); the server is the authority.
 */
import { useEffect, useState } from 'react';
import { Switch } from '@/components/ds';
import { useUserStore } from '@/stores/prioritization/userStore';
import { getBindByHierarchy, setBindByHierarchy } from '@/lib/assignmentService';

export function BindByHierarchySwitch({ workspaceId }: { workspaceId: string }) {
  const can = useUserStore((s) => s.can);
  const isAdmin = can('admin.settings');
  const [value, setValue] = useState<boolean | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getBindByHierarchy(workspaceId).then((v) => { if (!cancelled) setValue(v); });
    return () => { cancelled = true; };
  }, [workspaceId]);

  if (!isAdmin || value === null) return null;

  return (
    <div className="flex items-start gap-3 text-xs">
      <Switch
        checked={value}
        onChange={async (next) => {
          const res = await setBindByHierarchy(workspaceId, next);
          if (!res.ok) { setErr(res.error); return; }
          setErr(null); setValue(res.data.enabled);
        }}
        label="Authority above the assignee binds without acceptance"
        description={value
          ? 'On: an assignment authorized by someone above the assignee in the org chart is binding at once. The record still shows it was not accepted.'
          : 'Off: every assignment on a person or unit binds only when they accept it. Turning this on changes new assignments only.'}
      />
      {err && <span className="text-[var(--coral)]">{err}</span>}
    </div>
  );
}
